import React from 'react';
import { FILTER_COLLATION, FILTER_OPERATION, ModelRenderer } from '@veeam/core';
import { Combobox } from "../../controls/Combobox";
import { createDefaultOption } from "../../Suggest";
import { STACK_ALIGN, STACK_DIRECTION, StackView } from "../../StackView";
import { ToolbarText } from "../../Toolbar";
export function toolbarComboboxFilter(_a) {
    var title = _a.title, property = _a.property, _b = _a.groupId, groupId = _b === void 0 ? '' : _b, _c = _a.operation, operation = _c === void 0 ? FILTER_OPERATION.in : _c, _d = _a.collation, collation = _d === void 0 ? FILTER_COLLATION.ignorecase : _d, disabled = _a.disabled, decorators = _a.decorators, _e = _a.allValue, allValue = _e === void 0 ? null : _e, _f = _a.fieldConfig, fieldConfig = _f === void 0 ? {} : _f, items = _a.items;
    return {
        decorators: decorators,
        disabled: disabled,
        render: function (model, _a) {
            var disabled = _a.disabled;
            return (React.createElement(ModelRenderer, { model: model, render: function (_a) {
                    var value = _a.value;
                    var currentValue = value.filters.getFilterValue({ property: property, groupId: groupId }) || allValue;
                    if (Array.isArray(currentValue)) {
                        currentValue = currentValue[0];
                    }
                    return (React.createElement(StackView, { align: STACK_ALIGN.center, direction: STACK_DIRECTION.row },
                        !!title && React.createElement(ToolbarText, { text: title }),
                        React.createElement(Combobox, { value: currentValue, valueGetter: function (data) { return data.value; }, textGetter: function (data) { return data.title; }, size: fieldConfig.size, disabled: disabled, optionRenderer: createDefaultOption({
                                iconGetter: function (_a) {
                                    var option = _a.option;
                                    return option.icon || '';
                                }
                            }), data: items, onChange: function (nextValue) {
                                if (nextValue === allValue) {
                                    model.setFilter({ property: property, groupId: groupId }, {
                                        operation: operation,
                                        collation: collation,
                                        value: nextValue === allValue ? allValue : null
                                    });
                                    return;
                                }
                                model.setFilter({ property: property, groupId: groupId }, {
                                    operation: operation,
                                    collation: collation,
                                    value: operation === FILTER_OPERATION.in
                                        ? [nextValue]
                                        : nextValue
                                });
                            } })));
                } }));
        }
    };
}
//# sourceMappingURL=toolbarComboboxFilter.js.map